var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBenefitsOfSparkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.9688,
    cy: 24.5,
    r: 24,
    fill: "#067B65",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0957 9.96882C33.793 9.96283 32.5163 10.334 31.4197 11.0374C30.3232 11.7409 29.4537 12.7467 28.916 13.9334C28.3784 15.12 28.1957 16.4369 28.3899 17.7252C28.5841 19.0134 29.1469 20.2179 30.0104 21.1934L29.1618 26.0746L33.5832 23.3479C34.5137 23.5623 35.4789 23.5777 36.4157 23.393C37.3526 23.2083 38.2398 22.8276 39.0192 22.2761C39.7986 21.7245 40.4527 21.0144 40.9385 20.1924C41.4243 19.3703 41.7308 18.4549 41.8381 17.5061C41.9454 16.5573 41.8509 15.5965 41.5609 14.6868C41.2709 13.777 40.7918 12.9389 40.1552 12.2272C39.5186 11.5155 38.7388 10.9465 37.8669 10.5573C36.9949 10.1681 36.0506 9.96753 35.0957 9.96882Z",
    stroke: "#067B65",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1191 28.8594C18.1191 30.0156 18.5784 31.1244 19.396 31.9419C20.2135 32.7595 21.3223 33.2188 22.4785 33.2188C23.6347 33.2188 24.7435 32.7595 25.5611 31.9419C26.3786 31.1244 26.8379 30.0156 26.8379 28.8594C26.8379 27.7032 26.3786 26.5944 25.5611 25.7768C24.7435 24.9593 23.6347 24.5 22.4785 24.5C21.3223 24.5 20.2135 24.9593 19.396 25.7768C18.5784 26.5944 18.1191 27.7032 18.1191 28.8594Z",
    stroke: "#067B65",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2315 39.0222C28.5402 37.8443 27.5527 36.8677 26.3672 36.1895C25.1817 35.5112 23.8394 35.1548 22.4735 35.1558C21.1077 35.1567 19.7659 35.5148 18.5813 36.1947C17.3967 36.8745 16.4105 37.8524 15.7207 39.0313",
    stroke: "#067B65",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0957 27.4062V39.0313",
    stroke: "#067B65",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8145 39.0313V13.8438C12.8145 12.816 13.2227 11.8304 13.9494 11.1037C14.6761 10.377 15.6617 9.96875 16.6895 9.96875H26.377",
    stroke: "#067B65",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8145 17.7188H24.4395",
    stroke: "#067B65",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5645 13.8438H24.4395",
    stroke: "#067B65",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.002 16.1958C37.9432 16.9101 37.6051 17.5724 37.0609 18.039C36.5168 18.5055 35.8106 18.7385 35.0957 18.6874C34.3808 18.7385 33.6746 18.5055 33.1305 18.039C32.5863 17.5724 32.2482 16.9101 32.1895 16.1958",
    stroke: "#067B65",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.3655,
    cy: 13.701,
    r: 0.721009,
    fill: "#067B65"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.8387,
    cy: 13.701,
    r: 0.721009,
    fill: "#067B65"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitsOfSparkIcon);
export default __webpack_public_path__ + "static/media/BenefitsOfSparkIcon.387999456703b6c42634abc38d3b857d.svg";
export { ForwardRef as ReactComponent };